import
{
    FC,
    useCallback,
    useEffect,
    useRef,
    useState
} from "react";



import
{
    usePersistentState
} from "../Persistence";


import
{
    Filter
} from "../System/Reports/types/reportTypes";

import List from "../List/List";

import style from './PriceList.module.scss';

import
{
    PaginatedResult,
    PaginationRequest,
    PriceList
} from "@ews/react-data";

import
{
    useFetchPriceList
} from "../ReactData/misc";

import
{
    IonIcon
} from "@ionic/react";

import
{
    checkmark
} from "ionicons/icons";
import { Locale } from "../../setup/locale";
import { defaultPageRange } from "../List/Pagination/pagerange";
import { HeaderOption } from "../List/types";

const standardFilter: Filter<{}> = {
    sortCriteria: "priceList",
    sortOrder: "ASC",
    pageSize: defaultPageRange
};


type PersistentFilter = Filter<{}>;

const link = {
    'url': 'priceList',
    'paramsKey': 'id'
};

const header: HeaderOption<Locale, PriceList>[] = [
    {
        title: 'COM_FACPMANAGEMENT_FACP_MANAGER_PRICES',
        key: 'priceList',
        both: true,
    },
    {
        title: '[REACT_PRICE_LIST_IS_DEFAULT]',
        key: 'default',
        both: true,
        child: (priceList: PriceList) =>
        {
            return priceList.default ? <IonIcon size="large" color="success" icon={checkmark} /> : <></>;
        }

    },
];

const PriceListOverview: FC = () =>
{
    const [result, setResult] = useState<PaginatedResult<PriceList>>({
        currentPage: 0,
        pageSize: standardFilter.pageSize || defaultPageRange,
        totalCountOfEntries: 0,
        totalCountOfPages: 0,
        results: [],
    });

    const [state, setState] = usePersistentState<PersistentFilter>('priceList:filter', { ...standardFilter });
    const fetchPriceLists = useFetchPriceList();

    const sortCriteria = useRef<{
        key: string;
        direction: "ASC" | "DESC";
    } | undefined>(undefined);


    const handleFilterResponse = useCallback(async (filterCriteria: PaginationRequest) =>
    {
        const response: PaginatedResult<PriceList> = await fetchPriceLists(filterCriteria) as PaginatedResult<PriceList>;

        setResult(response);
    }, [fetchPriceLists]);

    useEffect(() =>
    {
        handleFilterResponse(state);
    }, [handleFilterResponse, state]);

    useEffect(() =>
    {
        sortCriteria.current =
            state.sortCriteria ? {
                key: state.sortCriteria,
                direction: state.sortOrder || "ASC"
            } : undefined;

    }, [state.sortCriteria, state.sortOrder]);

    const onPageChange = useCallback((page: PersistentFilter["page"]) => setState((prev) => ({ ...prev, page })), [setState]);
    const onSortChange = useCallback((sortCriteria: PersistentFilter["sortCriteria"], sortOrder: PersistentFilter["sortOrder"]) => setState((prev) => ({ ...prev, sortCriteria, sortOrder })), [setState]);
    const onPageSizeChange = useCallback((pageSize: PersistentFilter["pageSize"]) => setState((prev) => ({ ...prev, pageSize })), [setState]);


    return <div className={`${style.container}`}>
        <List
            link={link}
            headers={header}
            rows={result.results}
            sort={sortCriteria.current}

            onSort={onSortChange}
            onPageChange={onPageChange}
            onPageSize={onPageSizeChange}
            pageSize={result.pageSize}
            numberOfPages={result.totalCountOfPages}
            currentPage={result.currentPage}
        />
    </div>;

};

export default PriceListOverview;
